import { render, staticRenderFns } from "./MislakaShareConsent.vue?vue&type=template&id=f324635a&scoped=true"
import script from "./MislakaShareConsent.vue?vue&type=script&lang=js"
export * from "./MislakaShareConsent.vue?vue&type=script&lang=js"
import style0 from "./MislakaShareConsent.vue?vue&type=style&index=0&id=f324635a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f324635a",
  null
  
)

export default component.exports